


export const treeSelectedHeliocleanSitesGetters = {
    treeSelectedHeliocleanSitesFleet(state) {
        return state.treeSelectedHeliocleanSitesFleet
    }
};